import { Ally } from "../ally/Ally"
import { allies } from "../AllyMechanic"
import { ICharacterStats } from "../characters/Character"
import { TEnemydifficulty } from "../CreatingMechanic"
import { Enemy } from "../enemies/Enemy"
import { initPotion, Potion } from "../items/Potion"
import { soundToPlay } from "../sounds/sound"

export interface Ibackground {
    img: string
    webp: string
}

export interface IInitLocation {
    name: string
    difficulty: TEnemydifficulty
    maxLevels: number
    passsedLevels: number
    isCompleted: boolean
    background: Ibackground
    initEnemies: ICharacterStats[],
    index: number,
    boss: ICharacterStats
}

export class Location {
    private name: string
    private difficulty: TEnemydifficulty
    private maxLevels: number
    private passsedLevels: number
    private isCompleted: boolean
    private background: Ibackground
    private availableAllys: Ally[]
    private isAllyAdded: boolean
    private enemies: ICharacterStats[]
    private boss: ICharacterStats
    private index: number

    constructor(init: IInitLocation) {
        this.name = init.name
        this.difficulty = init.difficulty
        this.maxLevels = init.maxLevels
        this.passsedLevels = init.passsedLevels
        this.isCompleted = init.isCompleted
        this.background = init.background
        this.availableAllys = allies
        this.isAllyAdded = false
        this.enemies = init.initEnemies
        this.index = init.index
        this.boss = init.boss
    }

    getBackground() {
        return this.background
    }

    getIsComplete() {
        return this.isCompleted
    }

    getPassedLevels() {
        return this.passsedLevels
    }

    getMaxLevels() {
        return this.maxLevels
    }

    getName() {
        return this.name
    }

    getLoot() {
        const rndLoot = Math.floor(Math.random() * (1 - 0 + 1) + 0)
        const rndGold = Math.floor(Math.random() * (100 - 50 + 1) + 50)
        const healingPotion = new Potion(initPotion)
        soundToPlay("chest")

        switch (rndLoot) {
            case 0:
                return rndGold
            case 1:
            default:
                return healingPotion
        }
    }

    getLocationScene() {
        let maxRnd = 2
        if (this.isAllyAdded)
            maxRnd = 1

        const rndScene = Math.floor(Math.random() * (maxRnd - 0 + 1) + 0)

        if (this.getIsBoss()) {
            return "fight"
        }

        switch (rndScene) {
            case 0:
                return "fight"
            case 1:
                return "chest"
            case 2:
                return "dialog"
            default:
                return "fight"
        }
    }

    getIsBoss() {
        return this.passsedLevels === (this.maxLevels - 1)
    }

    getIsAllyAdded() {
        return this.isAllyAdded
    }

    getAlly() {
        const rndScene = Math.floor(Math.random() * (5 - 0 + 1) + 0)
        this.isAllyAdded = true
        return this.availableAllys[rndScene]
    }

    setIsComplete(value: boolean) {
        this.isCompleted = value
    }

    passLevel() {
        this.passsedLevels++
    }

    resetLevels() {
        this.passsedLevels = 0
    }

    private getRandomEnemy(locationNumber: number = 0) {
        const probability: number[][] = [
            [0.9, 0.1, 0],
            [0.2, 0.7, 0.1],
            [0.1, 0.5, 0.4],
            [0, 0.3, 0.7],
            [0, 0.1, 0.9],
            [0, 0, 1],
        ]
        const results = [0.8, 1, 1.2]

        let num = Math.random(),
            s = 0,
            lastIndex = probability[locationNumber].length - 1;

        for (var i = 0; i < lastIndex; ++i) {
            s += probability[locationNumber][i];
            if (num < s) {
                return results[i];
            }
        }

        return results[lastIndex];
    }

    private createEnemy(locationsSet: number) {
        const c = Math.round(locationsSet + 1 / 10)
        const rndStats = Math.floor(Math.random() * (this.enemies.length - 1 - 0 + 1) + 0)

        const newEnemy = new Enemy(
            {
                ...this.enemies[rndStats],
                initCharm: 10 * c * this.getRandomEnemy(this.index),
                initConstitution: 10 * c * this.getRandomEnemy(this.index),
                initDexterety: 10 * c * this.getRandomEnemy(this.index),
                initIntelligent: 10 * c * this.getRandomEnemy(this.index),
                initWisdom: 10 * c * this.getRandomEnemy(this.index),
                initStrength: 10 * c * this.getRandomEnemy(this.index),
                initName: "",
                initIsNpc: true
            },
            {
                name: "bones",
                images: { webp: "", img: "" },
                amount: Math.round(Math.random() * (10 - 1 + 1) + 1)
            }
        )

        return newEnemy
    }

    private createBoss(locationNumber: number, locationsSet: number) {
        const c = Math.round(1 + locationsSet / 10)

        return new Enemy({
            ...this.boss,
            initName: "BOSS", initCharm: 15 * c * this.getRandomEnemy(locationNumber),
            initConstitution: 15 * c * this.getRandomEnemy(locationNumber),
            initDexterety: 15 * c * this.getRandomEnemy(locationNumber),
            initIntelligent: 15 * c * this.getRandomEnemy(locationNumber),
            initWisdom: 15 * c * this.getRandomEnemy(locationNumber),
            initIsNpc: true
        },
            {
                name: "bones",
                images: { webp: "", img: "" },
                amount: Math.round(Math.random() * (10 - 1 + 1) + 1)
            })
    }

    private getRandom(locationNumber: number = 0) {
        const probability: number[][] = [
            [0.9, 0.1, 0, 0],
            [0.2, 0.7, 0.1, 0],
            [0, 0.1, 0.7, 0.2],
            [0, 0, 0.6, 0.4],
            [0, 0, 0.5, 0.5],
            [0, 0, 0.4, 0.6],
        ]
        const results = [0, 1, 2, 3]

        let num = Math.random(),
            s = 0,
            lastIndex = probability[locationNumber].length - 1;

        for (var i = 0; i < lastIndex; ++i) {
            s += probability[locationNumber][i];
            if (num < s) {
                return results[i];
            }
        }

        return results[lastIndex];
    }

    createEnemyArr(locationsSet: number) {
        if (this.passsedLevels === this.maxLevels)
            return [this.createBoss(this.index, locationsSet)]

        switch (this.getRandom(this.index)) {
            case 1:
                return [this.createEnemy(locationsSet), this.createEnemy(locationsSet)]
            case 2:
                return [this.createEnemy(locationsSet), this.createEnemy(locationsSet), this.createEnemy(locationsSet)]
            case 3:
                return [this.createEnemy(locationsSet), this.createEnemy(locationsSet), this.createEnemy(locationsSet), this.createEnemy(locationsSet)]
            case 0:
            default:
                return [this.createEnemy(locationsSet)]
        }
    }

    getIndex() {
        return this.index
    }

    getChestLoot() {
        const rndLoot = Math.floor(Math.random() * (1 - 0 + 1) + 0)
        const rndGold = Math.floor(Math.random() * (100 - 50 + 1) + 50)
        const healingPotion = new Potion(initPotion)
        soundToPlay("chest")

        switch (rndLoot) {
            case 0:
                return rndGold
            case 1:
            default:
                return healingPotion
        }
    }


}